export default {
	en: {
		translation: {
			google_drive: {
				no_auth_title: "Upload files from your Google Drive.",
				no_auth_action: "Connect to Google Drive",
				search: {
					placeholder: "Search...",
					reset: "Reset search",
				},
				grid: {
					folders: "Folders",
					files: "Files",
					empty_folder: "This folder is empty.",
				},
				recent: "Recent",
				starred: "Starred",
				my_drive: "My Drive",
				shared_drive: "Shared drives",
				search_results: "Search results",
				shared_with_me: "Shared with me",
				name: "Name",
				modifiedTime: "Last modified",
				modifiedByMeTime: "Last modified by me",
				viewedByMeTime: "Last opened by me",

				notifications: {
					retrieve_failed: "Failed to retrieve upload data from Google Drive.",
				},
			},
		},
	},
};
